function escapeHtml(text) {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function formatInline(raw) {
  let text = escapeHtml(raw);
  text = text.replace(/\*\*([^*]+)\*\*/g, "<strong>$1</strong>");
  text = text.replace(/__([^_]+)__/g, "<strong>$1</strong>");
  text = text.replace(/\*([^*\n]+)\*/g, "<em>$1</em>");
  return text;
}

export function renderChatMarkdown(text) {
  if (!text) {
    return "";
  }

  const lines = String(text).replace(/\r\n/g, "\n").split("\n");
  const blocks = [];
  let listItems = [];

  const flushList = () => {
    if (listItems.length) {
      blocks.push(`<ul>${listItems.join("")}</ul>`);
      listItems = [];
    }
  };

  for (const line of lines) {
    const bullet = line.match(/^\s*[*+-]\s+(.*)$/);

    if (bullet) {
      listItems.push(`<li>${formatInline(bullet[1])}</li>`);
      continue;
    }

    flushList();

    const trimmed = line.trim();
    if (!trimmed) {
      continue;
    }

    blocks.push(`<p>${formatInline(trimmed)}</p>`);
  }

  flushList();

  return blocks.join("");
}
